import {Button, Result, Col, Form, Input, Row} from 'antd';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {resetSendMail} from '../../../../Store/Actions';
import SectionLayout from '../../../CommonComponents/Layout/sectionLayout';
import './style.css';
import CommonHeroText from '../../../CommonComponents/CommonHeroText';
import {validateEmailInput} from '../../../../Util/commonUtility';
import {SEND_MAil_SUCCESS} from '../../../../Constant/ActionTypes';
import useLocalization from '../../../../Localization';

const ResetSendEmailComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {ApplicationString} = useLocalization();
  const [resetSendEmailForm] = Form.useForm();
  const {sendMailSuccess} = useSelector(({auth}) => auth);
  const onResetSendMail = (values) => {
    dispatch(resetSendMail(values));
  };
  // const redirection = (url) => {
  //   if (url === '/resetPassword') {
  //     sendMailSuccess = false;
  //   }
  //   navigate(url);
  // };
  return (
    <>
      <CommonHeroText
        heading={ApplicationString['resetPassword.heading']}
        subheading={ApplicationString['resetPassword.subheading']}
      />
      <Row justify='center' align='middle' style={{minHeight: '60vh'}}>
        <Col span={24}>
          <SectionLayout>
            {!sendMailSuccess && (
              <div className='reset-pass-container'>
                <div className='reset-pass-sub-container'>
                  <Form
                    name='reset_email_form'
                    initialValues={''}
                    onFinish={onResetSendMail}
                    form={resetSendEmailForm}>
                    <div className='reset-text-container'>
                      <p className='reset-page-heading'>
                        {ApplicationString['resetPassword.forgotPassword']}
                      </p>
                      <p className='sub-page-heading'>
                        {ApplicationString['resetPassword.enterEmail']}
                      </p>
                    </div>
                    <label className='reset-form-label-text'>
                      {ApplicationString['resetPassword.emailLabel']}
                    </label>
                    <Form.Item
                      name='email'
                      rules={[
                        {
                          required: true,
                          message: (
                            <span>
                              {ApplicationString['resetPassword.emailRequired']}
                            </span>
                          ),
                        },
                        {
                          validator: (_, value) =>
                            validateEmailInput(
                              value,
                              ApplicationString['resetPassword.emailLabel'],
                            ),
                        },
                      ]}>
                      <Input
                        prefixCls='common-input-user-login w-100'
                        className='reset-input'
                        placeholder='myemail@address.com'
                      />
                    </Form.Item>
                    <Form.Item className='text-center'>
                      <Button
                        type='primary'
                        htmlType='submit'
                        prefixCls='submit-login-page'
                        className='login-button extend-login-button'>
                        {ApplicationString['resetPassword.resetButtonText']}
                      </Button>
                    </Form.Item>
                    <Button onClick={() => navigate('/login')} type='text'>
                      {ApplicationString['resetPassword.backToSignIn']}
                    </Button>
                  </Form>
                </div>
              </div>
            )}
            {sendMailSuccess && (
              <div className='send-email-success'>
                <Result
                  status='success'
                  title={ApplicationString['resetPassword.successTitle']}
                  subTitle={ApplicationString['resetPassword.successSubTitle']}
                  extra={[
                    <Button
                      type='primary'
                      key='goto_signin'
                      className='goto_signin_button'
                      onClick={() => navigate('/login')}>
                      {ApplicationString['resetPassword.goToLogin']}
                    </Button>,
                    <Button
                      key='resend_mail'
                      onClick={() => {
                        dispatch({type: SEND_MAil_SUCCESS, payload: false});
                      }}
                      prefixCls='reset_back_button'>
                      {ApplicationString['resetPassword.resendEmail']}
                    </Button>,
                  ]}
                />
              </div>
            )}
          </SectionLayout>
        </Col>
      </Row>
    </>
  );
};

export default ResetSendEmailComponent;
